import { isEmpty, map } from 'lodash';

export default {
  availableTagsFormatted: (state) => {
    if (isEmpty(state.clinicTags) && !state.isDefaultTagsInitialized) {
      return map(state.defaultTags, (tag) => ({
        value: tag.id,
        label: tag.id,
        color: tag.color,
        textColor: tag.textColor,
      }));
    }

    return map(state.clinicTags, (tag) => ({
      value: tag.id,
      label: tag.id,
      color: tag.color,
      textColor: tag.textColor,
    }));
  }, // availableTagsFormatted()

  availableTags() {
    return this.availableTagsFormatted.map((tag) => (tag.value));
  }, // availableTags()
};
